export const eventsImageScrollerData = [
    {
        url: '/eventsImageScroller1.png',
        location: 'Washington DC',
        title: 'WiEP x International House'
    },
    {
        url: '/eventsImageScroller2.png',
        location: 'Pune',
        title: 'WiEP x Gokhale Institute of Politics and Economics'
    },
    {
        url: '/eventsImageScroller3.png',
        location: 'Mohali',
        title: 'WiEP x Indian School of Business (Mohali)'
    },
    {
        url: '/eventsImageScroller4.png',
        location: 'Mumbai',
        title: 'WiEP x Artha Global'
    },
    {
        url: '/eventsImageScroller2.png',
        location: 'Delhi',
        title: 'WiEP x Centre for Policy Research'
    },
    {
        url: '/eventsImageScroller6.png',
        location: 'Delhi',
        title: 'WiEP x IdInsight, Delhi'
    },
    {
        url: '/MadraSchool.png',
        location: 'Chennai',
        title: 'Session at Madras School of Economics - November 2025'
    },
    {
        url: '/gurugobind.png',
        location: 'Delhi',
        title: 'Educational Session at Sri Guru Gobind Singh College Of Commerce - 2024'
    },
    {
        url: '/TERIMumbai.png',
        location: 'Mumbai',
        title: 'Session at TERI, Mumbai - November 2025'
    },
    {
        url: '/dc.png',
        location: 'Washington DC',
        title: 'WiEP Social in DC with Anahita'
    },
    {
        url: '/GokhaleInstituteofpolitics.png',
        location: 'Pune',
        title: 'Team Back in 2020 - Gokhale Institute'
    },
    {
        url: '/Chai.png',
        location: 'India',
        title: "WiEP's First Mixer Chai - 2021"
    }
]

export default eventsImageScrollerData;